

import React, { useState, useEffect } from "react";
import { Radio, Input, Button, Card, Form, notification } from "antd";
import { Wallet, CreditCard, DollarSign } from "lucide-react";
import "./styles.scss";
import { Row, Col, Container } from "react-bootstrap";
import Header from "../../component/header";
import { API } from "../../Config/API";
import { POST } from "../../utils/apiCalls";
import gpay from "../../asset/images/google-pay-icon-svgrepo-com.svg";
import visa from "../../asset/images/visa-svgrepo-com.svg";
import master from "../../asset/images/mastercard-svgrepo-com.svg";
import paypal from "../../asset/images/paypal-logo-svgrepo-com.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setSubscriptions,
  updateSubscription,
} from "../../redux/slices/subscription";

declare global {
  interface Window {
    easebuzzCheckout: any;
  }
}

interface PlanState {
  planName: string;
  price: string;
  numericPrice: number;
  currency: string;
  period: string;
  description: string;
  features: string[];
}

const CheckoutPage = () => {
  const user = useSelector((state: any) => state?.User?.user);
  const location = useLocation();
  const planDetails = location.state as PlanState;
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPayment, setSelectedPayment] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log("usr -- ", user?.id);

  // Exchange rates (hardcoded for simplicity; replace with API in production)
  const exchangeRates: { [key: string]: number } = {
    $: 84.0, // 1 USD = 84 INR
    QR: 23.0, // 1 QAR = 23 INR
    "₹": 1.0, // 1 INR = 1 INR
  };

  // Function to convert price to INR
  const convertToINR = (price: number, currency: string): number => {
    const rate = exchangeRates[currency] || 1.0;
    return price * rate;
  };

  // Get the converted INR price
  const inrPrice = planDetails
    ? convertToINR(planDetails.numericPrice, planDetails.currency)
    : 0;

  const loadData = async (obj: any) => {
    try {
      setIsLoading(true);
      let url = API.EPAPER;
      const response: any = await POST(url, obj);
      if (response?.length) {
        setData(response);
      } else {
        setData([]);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const handlePaymentChange = (e: any) => {
    setSelectedPayment(e.target.value);
  };

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const payload = {
        amount: inrPrice.toFixed(2),
        productInfo: planDetails?.planName || "Subscription",
        name: values.FirstName,
        email: values.Email,
        phone: values.Phone,
        web_user: user?.id,
        edition_type: values.edition_type,
        description: planDetails?.description,
        plan: planDetails?.planName,
        status: "active",
        start_date: new Date().toISOString(),
        end_date: new Date(
          new Date().setMonth(new Date().getMonth() + 1)
        ).toISOString(),
        duration_months: 1,
      };

      // Get payment URL from backend
      const response: any = await POST("ease-buzz-payment/initiate", payload);

      if (response?.redirect) {
        window.location.href = response.redirect;
      } else {
        throw new Error("Payment Failed");
      }
    } catch (error: any) {
      setLoading(false);
      notification.error({
        message: "Payment Failed",
        description: error || "Could not initiate payment",
      });
    }
  };
  const paymentsOptions = [
    {
      image: paypal,
      size: "75px",
    },
    {
      image: visa,
      size: "40px",
    },
    {
      image: master,
      size: "40px",
    },
    {
      image: gpay,
      size: "40px",
    },
  ];

  return (
    <>
      <Header onChange={(val: any) => loadData(val)} />
      <div className="checkout-container">
        <Container>
          <Row className="checkout-row">
            <Col lg={7} md={12} className="mb-4">
              <div className="payment-section">
                <h2>Personal Details</h2>
                <p className="security-text">
                  All transactions are secure and encrypted
                </p>
                <hr style={{ height: "1px", background: "#e8e8e8" }} />
                <Form
                  form={form}
                  onFinish={onFinish}
                  name="payment_form"
                  layout="vertical"
                >
                  <div className="payment-options">
                    <Row>
                      <Col md={6}>
                        <label>First Name</label>
                        <Form.Item
                          name="FirstName"
                          rules={[
                            {
                              required: true,
                              message: "Please enter your first name",
                            },
                          ]}
                        >
                          <Input placeholder="First Name" />
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <label>Last Name</label>
                        <Form.Item
                          name="LastName"
                          rules={[
                            {
                              required: true,
                              message: "Please enter your last name",
                            },
                          ]}
                        >
                          <Input placeholder="Last Name" />
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <label>Email Address</label>
                        <Form.Item
                          name="Email"
                          rules={[
                            {
                              required: true,
                              type: "email",
                              message: "Please enter a valid email address",
                            },
                          ]}
                        >
                          <Input placeholder="Email Address" />
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <label>Phone Number</label>
                        {/* <Form.Item
                          name="Phone"
                          rules={[
                            {
                              required: true,
                              message: "Please enter your phone number",
                            },
                          ]}
                        >
                          <Input placeholder="Phone Number" />
                        </Form.Item> */}
                        <Form.Item
                          name="Phone"
                          rules={[
                            {
                              required: true,
                              message: "Please enter your phone number",
                            },
                            {
                              pattern: /^\d{10}$/,
                              message: "Phone number must be exactly 10 digits",
                            },
                          ]}
                        >
                          <Input placeholder="Phone Number" />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      {paymentsOptions.map((item: any, index: number) => {
                        return (
                          <Col md={3} key={index}>
                            <div
                              style={{
                                border: "1px solid #e8e8e8",
                                borderRadius: "10px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                padding: "10px",
                              }}
                            >
                              <img
                                style={{
                                  width: `${item?.size}`,
                                }}
                                src={item?.image}
                                alt="Payment Option"
                              />
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </div>

                  <Form.Item
                    name="terms"
                    valuePropName="checked"
                    rules={[
                      {
                        validator: (_, value) =>
                          value
                            ? Promise.resolve()
                            : Promise.reject(
                                "You must agree to the Terms & Conditions"
                              ),
                      },
                    ]}
                  >
                    <div className="terms">
                      <input type="checkbox" />
                      <span>
                        By clicking this, I agree to have Terms & Conditions and
                        Privacy Policy
                      </span>
                    </div>
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      block
                      className="pay-button"
                      loading={loading}
                    >
                      Pay {planDetails?.currency}{" "}
                      {planDetails?.numericPrice.toFixed(2)} (₹{" "}
                      {inrPrice.toFixed(2)})
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>

            <Col lg={5} md={12}>
              <div className="cart-section">
                <Card title="Your Purchase (1)" className="cart-card">
                  <div className="cart-items">
                    <div className="cart-item">
                      <img
                        src="https://e-files.suprabhaatham.com/20-02-2025/Qatar/2025-02-20-15-02-02-024-epaper-thumb-0-Qatar.jpeg"
                        alt="E-paper Thumbnail"
                      />
                      <div className="item-details">
                        <h4>Edition :</h4>
                        <span className="qty">{planDetails?.planName}</span>
                        <span className="price">
                          {planDetails?.currency}{" "}
                          {planDetails?.numericPrice.toFixed(2)} (₹{" "}
                          {inrPrice.toFixed(2)})
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="order-summary">
                    <h3>Summary</h3>
                    <div className="summary-row">
                      <span>Subtotal</span>
                      <span>
                        {planDetails?.currency}{" "}
                        {planDetails?.numericPrice.toFixed(2)} (₹{" "}
                        {inrPrice.toFixed(2)})
                      </span>
                    </div>
                    <div className="summary-row total">
                      <span>Total</span>
                      <span>
                        {planDetails?.currency}{" "}
                        {planDetails?.numericPrice.toFixed(2)} (₹{" "}
                        {inrPrice.toFixed(2)})
                      </span>
                    </div>
                  </div>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CheckoutPage;
